<app-employee-menu></app-employee-menu>
<main role="main">
    <div class="container">
        <div class="row">
            <div class="col">
                <h1 class="mat-headline-3">Registrera ny användare</h1>
            </div>
        </div>
        <app-employee-form [companyId]="companyId" [employmentTypeId]="employmentTypeId" (saved)="saved($event)">
        </app-employee-form>
    </div>
</main>
<app-employee-footer></app-employee-footer>
